import { PlatformDataType } from "../platforms/PlatformsData";

export class ViewModelBridge {
    static afterConnected: () => void;
    static afterDisConnected: () => void;
}